import { mapGetters } from 'vuex';
import { isMarketSingle, isMarketSettled, isMarketExpired, isMarketSuspended, isMarketStatusClosed } from '@/utils/helpers';
import smallModal from '@/components/generics/modal/small/small.vue';


export default {
  components: {
    smallModal,
  },
  props: {
    market: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isMarketSettled,
      isMarketExpired,
      isMarketSuspended,
      isMarketStatusClosed,
      isMarketSingle,
      showDetails: false,
    };
  },
  computed: {
    ...mapGetters('app', [
      'isLayoutDesktop', 'isLayoutMobile', 'isCommentEnabled',
      'isAfterHours', 'isRegularMaintenance', 'isExtendedMaintenance',
      'isPinningEnabled', 'hasMaintenanceSuspended'
    ]),
    settledOutcome() {
      if (this.market.contracts.length === 0) {
        return 'Please check the outcome.'
      }
      if (this.isMarketSingle(this.market)) {
        const isWinnerYes = this.market.contracts[0].settledStatus === 1;
        return `${isWinnerYes ? 'YES' : 'NO'} is the outcome.`;
      }

      const contract = this.market.contracts.find((i) => i.settledStatus === 1);
      if (contract) {
        return `${contract.contractName} is the outcome.`
      }
      return 'Please check the outcome.'
    },
    show() {
      return !!this.theme;
    },
    theme() {
      if (this.hasMaintenanceSuspended && isMarketSuspended(this.market)) {
        return '';
      }
      if (isMarketSettled(this.market)) {
        return 'settled';
      }

      if (isMarketExpired(this.market)) {
        return 'expired';
      }

      if (isMarketSuspended(this.market)) {
        return 'expired';
      }

      if (isMarketStatusClosed(this.market)) {
        return 'expired';
      }

      return '';
    },
    title() {
      if (isMarketSettled(this.market)) {
        return 'Settled';
      }

      if (isMarketExpired(this.market)) {
        return 'Pending Settlement';
      }

      if (isMarketSuspended(this.market)) {
        return 'Suspended';
      }

      if (isMarketStatusClosed(this.market)) {
        return 'Closed';
      }

      return '';
    },
    classModifiers() {
      return {
        'market-alert-v2': true,
        [`market-alert-v2--${this.theme}`]: this.theme,
      };
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/market/v2/market-alert-v2/market-alert-v2.js